export const COFFRE_GRID_TILE_KEY = "coffre_grid_tile_px";
export const COFFRE_GRID_TILE_MIN = 88;
export const COFFRE_GRID_TILE_MAX = 220;
export const COFFRE_GRID_TILE_DEFAULT = 144;

export function clampCoffreGridTilePx(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return COFFRE_GRID_TILE_DEFAULT;
  return Math.min(COFFRE_GRID_TILE_MAX, Math.max(COFFRE_GRID_TILE_MIN, Math.round(n)));
}

export function readCoffreGridTilePx() {
  try {
    const raw = localStorage.getItem(COFFRE_GRID_TILE_KEY);
    if (raw == null || raw === "" || Number(raw) === 128) {
      return COFFRE_GRID_TILE_DEFAULT;
    }
    return clampCoffreGridTilePx(raw);
  } catch {
    return COFFRE_GRID_TILE_DEFAULT;
  }
}

export function persistCoffreGridTilePx(px) {
  try {
    localStorage.setItem(COFFRE_GRID_TILE_KEY, String(clampCoffreGridTilePx(px)));
  } catch {
    /* ignore */
  }
}
